import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class OnBeforeNavigationMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('OnBeforeNavigationMessage', OnBeforeNavigationMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');